//Permanent
const twitterAccount = "elcomercio_peru";    
const urlMarca = "https://elcomercio.pe/";
const urlPortadaMarca = "https://especiales.elcomercio.pe/?q=especiales/especiales-el-comercio/index.html";
const domainMarca = "https://especiales.elcomercio.pe/?q=especiales/";
const domainAssets = 'https://d1ts5g4ys243sh.cloudfront.net/proyectos_especiales_prod/especiales/';
const slugCommonAssets2 = 'elementos-comunes-2/';

//Variables
const titleEspecial = 'Selecciones clasificadas al mundial Qatar 2022';
const socialShareText = "Selecciones clasificadas al mundial Qatar 2022 | El Comercio";
const slugEspecial = "selecciones-clasificadas-mundial-qatar-2022-nndd-ecvisual-ecpm";
const urlEspecial = `${domainMarca}${slugEspecial}/index.html`;
const urlAssets = `${domainAssets}${slugEspecial}`;
const urlCommonAssets = `${domainAssets}${slugCommonAssets2}`;
const queryStrStart = '&';
const urlJsonTeams = `${domainAssets}${slugEspecial}/json/teams.json`;
const queryStrParam = 'seleccion';

export { 
    twitterAccount, 
    urlCommonAssets,
    urlMarca, 
    urlPortadaMarca, 
    domainAssets, 
    domainMarca, 
    titleEspecial, 
    socialShareText, 
    slugEspecial, 
    urlAssets, 
    urlEspecial, 
    urlJsonTeams,
    queryStrStart, 
    queryStrParam 
}